import React from "react"
import { MDBContainer } from "mdbreact"

export default function Divider() {
  return (
    <MDBContainer>
      <hr />
    </MDBContainer>
  )
}
